import { ILocation } from '@/models/location';
import { getLabelInfo } from './getLabelInfo';

export function groupLocationsByCity(locations: Array<ILocation> = []) {
  let locationsByCityAndState: Record<string, ILocation[]> = {};

  for (const location of locations) {
    const cityAndState = getLabelInfo(['city', 'state'], location);

    if (!locationsByCityAndState[cityAndState]) {
      locationsByCityAndState[cityAndState] = [];
    }

    locationsByCityAndState[cityAndState].push(location);
  }

  return locationsByCityAndState;
}
